import React from 'react';
import { useNavigate } from 'react-router-dom';
import dholakImage from './assets/dholak.png';

function CategoryGrid({ productTypes = [] }) {
  const navigate = useNavigate();

  const categoryImages = {
    'Mridangas': 'https://mridangas-buacket.s3.us-east-1.amazonaws.com/media/products/webp/balaram.webp',
    'Dholak': 'https://mridangas-buacket.s3.us-east-1.amazonaws.com/media/products/webp/dholak.webp',
    'Kartals': 'https://mridangas-buacket.s3.us-east-1.amazonaws.com/media/products/webp/kartal1.webp',
    'Harmonium': 'https://mridangas-buacket.s3.us-east-1.amazonaws.com/media/products/webp/beginner+harmonium.webp',
    'Djembe': 'https://mridangas-buacket.s3.us-east-1.amazonaws.com/media/products/webp/puna+djambe.webp',
    'Bags': 'https://mridangas-buacket.s3.us-east-1.amazonaws.com/media/products/webp/bag.webp',
    'Covers': 'https://mridangas-buacket.s3.us-east-1.amazonaws.com/media/products/webp/cover.webp',
    'Whomper': 'https://mridangas-buacket.s3.us-east-1.amazonaws.com/media/products/webp/whomper.webp',
  };

  const defaultCategories = [
    { type_id: 8, type_name: 'Mridangas', image: categoryImages['Mridangas'] },
    { type_id: 11, type_name: 'Dholak', image: categoryImages['Dholak'] },
    { type_id: 9, type_name: 'Kartals', image: categoryImages['Kartals'] },
    { type_id: 1, type_name: 'Harmonium', image: categoryImages['Harmonium'] },
    { type_id: 4, type_name: 'Djembe', image: categoryImages['Djembe'] },
    { type_id: 2, type_name: 'Bags', image: categoryImages['Bags'] },
    { type_id: 7, type_name: 'Covers', image: categoryImages['Covers'] },
    { type_id: 6, type_name: 'Whomper', image: categoryImages['Whomper']}
  ];

  const displayCategories = productTypes.length > 0 ? productTypes : defaultCategories;

  return (
    <section className="bg-[#F2F1EC] px-4 py-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-[#2C2A27] text-xs uppercase tracking-widest font-semibold px-2 pb-4 text-[#9A7B56]">
          Shop by Category
        </h2>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4 px-2">
          {displayCategories.map((cat) => (
            <div
              key={cat.type_id}
              onClick={() => navigate(`/category/${cat.type_id}`)}
              className="bg-[#FDFDFB] border border-[#E1DFD7] rounded-md overflow-hidden cursor-pointer p-2 flex flex-col items-center justify-between transition-all duration-300 hover:border-[#9A7B56] hover:shadow-xs group"
            >
              <div
                className="w-full aspect-square bg-cover bg-center rounded-sm bg-[#F2F1EC] mix-blend-multiply transition-transform duration-500 group-hover:scale-102"
                style={{
                  backgroundImage: `url(${cat.image || categoryImages[cat.type_name] || dholakImage})`
                }}
              ></div>
              
              <div className="pt-3 pb-1 w-full text-center">
                <p className="text-[#2C2A27] text-[11px] uppercase tracking-wider font-medium truncate group-hover:text-[#9A7B56] transition-colors">
                  {cat.type_name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CategoryGrid;